<template>
  <div class="technologybox">
    <section id="banner">
      <div
        class="wrapper"
        :style="{background: 'url(' + categoryInfo.categoryPic + ') no-repeat center center'}"
      >
        <!-- <div class="inner_wrapper"> -->
        <!-- <fieldset>
            <legend>稳定性</legend>
            <div>
              <h2>供电不稳时，数据仍万无一失</h2>
            </div>
        </fieldset>-->
        <!-- </div> -->
      </div>
    </section>
    <section id="breadcrumb" style="position: static; top: 0px;">
      <div class="wrapper">
        <img src="../assets/breadcrumb.png" />
        <router-link :to="{path: '/'}">回首页</router-link>&nbsp;&gt;&nbsp;
        <a>核心技术</a>
      </div>
    </section>
    <div class="contentbox">
      <div class="contentt">
        <h1>HDSTOR 的技术特点</h1>

        <p>HDSTOR 拥有自主知识产权的固态存储和存储系统前沿技术</p>
      </div>
      <div class="contentul">
        <ul>
          <li v-for="item in list" :key="item.id" @click="chooseThis(item)" :class="{'active': activeItem.id == item.id}">
            <div>
              <img :src="item.logo" alt />
            </div>
            <h2>{{item.name}}</h2>
            <p>{{item.desc}}</p>
          </li>
          <!-- <li>
            <div>
              <img src="../assets/hexin2.png" alt />
            </div>
            <h2>FPGA开发技术</h2>
            <p>强制多接口开发能力(SATA/PCIE/USB/SRIO)，介绍325t/690t</p>
          </li>
          <li>
            <div>
              <img src="../assets/hexin3.png" alt />
            </div>
            <h2>SSD固件技术</h2>
            <p>专为特殊场景设计，定制功能(分区保护/分区访问控制/数据隐藏/可信等）</p>
          </li>
          <li>
            <div>
              <img src="../assets/hexin4.png" alt />
            </div>
            <h2>高可靠PCB设计技术</h2>
            <p>掉电保护，散热，浪涌等</p>
          </li>
          <li>
            <div>
              <img src="../assets/hexin5.png" alt />
            </div>
            <h2>存储全协议栈开发技术</h2>
            <p>设计源于企业级中高端存储已通过市场长期考验</p>
          </li> -->
        </ul>
      </div>
    </div>
    <div class="techabout">
      <div class="tech-fun">
        <div class="tfbox">
          <div class="tfbox-top">
            <div class="tft_left">
              <span>{{activeItem.title}}</span>
              <h3>
                {{activeItem.subtitle}}
              </h3>
              <p>{{activeItem.content}}</p>
            </div>
            <div class="tft_right">
              <img :src="activeItem.pic" alt />
            </div>
          </div>
          <div class="tfbox-bot">
            <!-- <h4>测试项目包括</h4> -->
            <ul>
              <li v-for="item in activeItem.technologyExamples" :key="item.id">
                <img :src="item.icon" alt />
                <p>{{item.name}}</p>
              </li>
              <!-- <li>
                <img src="../assets/hexinb2.png" alt />
                <p>严苛的掉点测试</p>
              </li>
              <li>
                <img src="../assets/hexinb3.png" alt />
                <p>严苛的掉点测试</p>
              </li>
              <li>
                <img src="../assets/hexinb4.png" alt />
                <p>严苛的掉点测试</p>
              </li>
              <li>
                <img src="../assets/hexinb5.png" alt />
                <p>严苛的掉点测试</p>
              </li>
              <li>
                <img src="../assets/hexinb6.png" alt />
                <p>严苛的掉点测试</p>
              </li>
              <li>
                <img src="../assets/hexinb7.png" alt />
                <p>严苛的掉点测试</p>
              </li>
              <li>
                <img src="../assets/hexinb8.png" alt />
                <p>严苛的掉点测试</p>
              </li> -->
            
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import { getCategoryInfo } from "@/api/content";
import { queryList } from '@/api/technology'
export default {
  name: "",
  data() {
    return {
      categoryId: this.$route.query.categoryId,
      categoryInfo: {},
      list: [],
      activeItem: {
        technologyExamples: []
      }
    };
  },
  mounted() {
    this.getBanner();
    this.getList()
  },
  methods: {
    getBanner() {
      // console.log(this.categoryId)
      getCategoryInfo(this.categoryId).then((res) => {
        if (res.code !== 200) return;
        this.categoryInfo = res.data;
        this.categoryInfo.categoryPic =
          process.env.BASE_API + "/web" + this.categoryInfo.categoryPic;
      });
    },
    getList() {
      queryList().then(res => {
        this.list = res.data
        this.list.forEach(item => {
          item.logo = process.env.BASE_API + "/web" + item.logo;
          item.pic = process.env.BASE_API + "/web" + item.pic;
          item.technologyExamples.forEach(e => {
            e.icon = process.env.BASE_API + "/web" + e.icon;
          })
        })
        this.activeItem = this.list[0]
      })
    },
    chooseThis(item) {
      this.activeItem = item
    }
  },
};
</script>

<style scoped >
.contentbox {
  text-align: center;
  padding: 50px 0;
  overflow: hidden;
  width: 100%;
  background-color: #fff;
  background: url(../assets/hexincb.png) no-repeat;
  background-size: 100% 100%;
}
@media screen and (max-width: 760px) {
  div.contentbox{
    background: none;
     padding: 20px 0;
  }
}
@media screen and (max-width: 760px) {
  div.contentbox .contentt{
   padding: 0px 20px;

  }
}
.contentbox .contentt {
  display: inline-block;
  margin-top: 20px;
  text-align: center;
  padding: 20px 40px;
  margin: 0 auto;
  color: #5f616d;
  border-radius: 5px;
}
@media screen and (max-width: 760px) {
 div.contentbox .contentt h1{
   font-size: 20px;
  line-height: 40px;
  }
}
.contentbox .contentt h1 {
  font-size: 40px;
  line-height: 60px;
  font-weight: normal;
}
@media screen and (max-width: 760px) {
 div.contentbox .contentt p{
   font-size: 14px;
  line-height: 18px;
  }
}
.contentbox .contentt p {
  font-size: 16px;
  line-height: 20px;
}

.contentul {
  width: 100%;
  margin: 0 auto;
}

@media screen and (max-width: 1300px) {
  .contentbox .contentul ul {
    width: 96%;
  }
}
.contentul ul {
  /* padding: 20px 0 0; */
  width: 75%;
  overflow: hidden;
  margin: 0 auto;
}
@media screen and (max-width: 1000px) {
  .contentbox .contentul ul li {
    height: 260px;
    margin: 10px 1%;
  }
}
@media screen and (max-width: 760px) {
  .contentbox .contentul ul {
    width: 100%;
  }
}
@media screen and (max-width: 760px) {
  .contentbox .contentul ul li {
    margin: 10px 1%!important;
    width:46%;
    height: 160px;
  }
}
.contentul ul li {
  width: 16%;
  padding: 10px 1%;
  margin: 10px 1%;
  float: left;
  height: 244px;
  overflow: hidden;
}
.contentul ul li:nth-child(1) {
  margin-top: 77px;
}
.contentul ul li:nth-child(2) {
  margin-top: 94px;
}
.contentul ul li:nth-child(3) {
  margin-top: 70px;
}
.contentul ul li:nth-child(4) {
  margin-top: 145px;
}
.contentul ul li:nth-child(5) {
  margin-top: 80px;
}
.contentul li:hover {
  border-radius: 15px;
  -moz-box-shadow: 0 0 30px #e0e0e0;
  -webkit-box-shadow: 0 0 30px #e0e0e0;
  box-shadow: 0 0 30px #e0e0e0;
  border: 2px #e0e0e0 solid\9;
}
.contentul li.active {
  border-radius: 15px;
  -moz-box-shadow: 0 0 30px #e0e0e0;
  -webkit-box-shadow: 0 0 30px #e0e0e0;
  box-shadow: 0 0 30px #e0e0e0;
  border: 2px #e0e0e0 solid\9;
}

.contentul li.active p {
  display: block;
}

@media screen and (max-width: 760px) {
  .contentbox .contentul ul li div {
    width: 70px;
    height: 70px;
    margin: 0 auto;
  }
}
.contentul ul li div {
  width: 120px;
  height: 120px;
  margin: 0 auto;
}
.contentul li div img {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 760px) {
  .contentbox .contentul ul li h2 {
    font-size: 14px;
    margin-top: 4px 0;
  }
}
.contentul li h2 {
  margin-top: 10px 0;
  text-align: center;
  font-size: 16px;
  line-height: 24px;
  color: #146cbd;
}
@media screen and (max-width: 760px) {
  .contentbox .contentul ul li p {
    font-size: 14px;
    line-height: 20px;
  }
}
.contentul li:hover p {
  display: block;
}
.contentul li p {
  display: none;
  text-align: center;
  font-size: 14px;
  line-height: 24px;
  color: #5f616d;
  word-break: break-all;
}

@media screen and (max-width: 760px) {
  section#banner .wrapper {
    height: 160px;
  }
}
@media screen and (max-width: 1000px) {
  #banner .wrapper {
    background-size: auto 100%;
  }
}
#banner .wrapper {
  position: relative;
  width: 100%;
  height: 312px;
  box-sizing: border-box;
  background: url(../assets/20171018-15473919.jpg) no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

#banner .wrapper {
  background-size: auto 100% !important;
}
@media screen and (max-width: 1300px) {
  .technologybox section .wrapper {
    width: 100%;
  }
}

section .wrapper {
  width: 1280px;
  margin: 0 auto;
  box-sizing: border-box;
  text-align: center;
  overflow: hidden;
}
@media screen and (max-width: 760px) {
  section#banner .wrapper .inner_wrapper {
    width: 100%;
    height: 160px;
    padding: 10px;
  }
}
#banner .wrapper .inner_wrapper {
  width: 1280px;
  height: 312px;
  margin: auto;
  padding: 30px 40px 0;
  box-sizing: border-box;
  color: #fff;
}
@media screen and (max-width: 760px) {
  section#banner .wrapper fieldset {
    border: 1px solid #fff;
    padding: 0 10px 10px;
    width: 220px;
  }
}
#banner .wrapper fieldset {
  border: 2px solid #fff;
  padding: 10px 30px 20px;
  width: 360px;
  box-sizing: border-box;
  text-align: left;
  font-family: "LatoWebBold";
}
@media screen and (max-width: 760px) {
  section#banner .wrapper fieldset legend {
    font-size: 12px;
  }
}
#banner .wrapper fieldset legend {
  font-family: "LatoWebBold";
  font-weight: normal;
  padding: 5px 10px;
  font-size: 19px;
  text-align: left;
}
@media screen and (max-width: 760px) {
  section#banner .wrapper h2 {
    font-size: 16px;
  }
}
#banner .wrapper h2 {
  margin: 0;
  font-size: 26px;
  font-family: "LatoWeb";
  font-weight: normal;
}
#breadcrumb {
  width: 100%;
  color: #fff;
  background: #c8c9cb;
}
@media screen and (max-width: 760px) {
  section#breadcrumb .wrapper {
    padding: 10px;
    font-size: 12px;
  }
}
#breadcrumb .wrapper {
  padding: 13px 40px;
  line-height: 16px;
  text-align: left;
  font-size: 14px;
  color: #333;
}
#breadcrumb .wrapper img {
  vertical-align: top;
  margin-right: 5px;
}
img {
  border: none;
  max-width: 100%;
  vertical-align: middle;
}
#breadcrumb .wrapper a {
  color: #333;
}
@media screen and (max-width: 760px) {
  section#content #tabs {
    padding: 20px;
    background: #f7f7f7;
    text-align: center;
  }
}
#content #tabs {
  padding: 35px;
  background: #f7f7f7;
  text-align: center;
}
#content #tabs .tabTitle {
  margin-bottom: 30px;
  font-family: "LatoWebBold";
  font-size: 16px;
}
#content #tabs .tab.current {
  background: url(../assets/20171130-11360244.png) center bottom no-repeat;
  background-size: 100% auto;
}
@media screen and (max-width: 760px) {
  section#content #tabs .tab {
    width: 80px;
    height: 80px;
    margin-bottom: 10px;
  }
}
#content #tabs .tab1 {
  background: url(../assets/20171130-11360244.png) center top no-repeat;
}
#content #tabs .tab2 {
  background: url(../assets/20171219-18240956.png) center top no-repeat;
}
#content #tabs .tab3 {
  background: url(../assets/20170630-09524123.png) center top no-repeat;
}
#content #tabs .tab4 {
  background: url(../assets/20170519-15510023.png) center top no-repeat;
}
#content #tabs .tab5 {
  background: url(../assets/20180521-13212732.png) center top no-repeat;
}
#content #tabs .tab6 {
  background: url(../assets/20180709-0906028.png) center top no-repeat;
}
#content #tabs .tab7 {
  background: url(../assets/20181127-13320079.png) center top no-repeat;
}
#content #tabs .tab {
  display: inline-block;
  margin: 0 5px;
  width: 100px;
  height: 100px;

  background-size: 100% auto;
  cursor: pointer;
}
@media screen and (max-width: 1000px) {
  section#content .wrapper {
    width: 100%;
    padding: 40px 20px;
  }
}
#content .wrapper {
  width: 960px;
  padding: 40px 0;
  box-sizing: border-box;
}
@media screen and (max-width: 760px) {
  section#content .wrapper .title {
    font-size: 30px;
    font-family: "LatoWebBold";
  }
}
#content .wrapper .title {
  font-size: 36px;
  color: #146cbd;
  padding: 20px 0 10px;
  font-family: "LatoWebBold";
}
#content .wrapper .des {
  line-height: 32px;
  font-size: 18px;
  padding: 40px 0 40px;
  font-family: "LatoWebLight";
  color: #666;
}
#content .feature_wrapper {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
@media screen and (max-width: 760px) {
  section#content .feature_wrapper .feature_item,
  section#content .benefit_wrapper .benefit_inner,
  section#content .system_wrapper .system_inner,
  section#content .feature_wrapper .feature_item .col,
  section#content .feature_wrapper .feature_item .col2,
  section#content .feature_wrapper .feature_item .col2 img {
    width: 100%;
  }
}
@media screen and (max-width: 1000px) {
  #content .feature_wrapper .feature_item,
  #content .benefit_wrapper .benefit_inner,
  #content .system_wrapper .system_inner {
    width: 100%;
  }
}
#content .feature_wrapper .feature_item {
  /* width: 1000px; */
  text-align: center;
  /* padding: 40px 0; */
  margin: auto;
  box-sizing: border-box;
  overflow: hidden;
}
@media screen and (max-width: 760px) {
  section#content .feature_wrapper .feature_item,
  section#content .benefit_wrapper .benefit_inner,
  section#content .system_wrapper .system_inner,
  section#content .feature_wrapper .feature_item .col,
  section#content .feature_wrapper .feature_item .col2,
  section#content .feature_wrapper .feature_item .col2 img {
    width: 100%;
  }
}
@media screen and (max-width: 760px) {
  section#content .feature_wrapper .col {
    padding: 0;
    text-align: center;
  }
}
@media screen and (max-width: 760px) {
  section#content .wrapper .col {
    display: block;
    width: 100%;
    margin: 20px 0;
  }
}
#content .wrapper .col {
  display: inline-block;
  width: 46%;
  margin: 0 2%;
  box-sizing: border-box;
  text-align: left;
  line-height: 26px;
  font-size: 16px;
}
#content .feature_wrapper .col {
  display: inline-block;
  width: 46%;
  /* padding: 0 5%; */
  box-sizing: border-box;
  text-align: left;
  vertical-align: middle;
}
.fl_left {
  float: left;
}
@media screen and (max-width: 760px) {
  section#content .feature_wrapper .col .title2 {
    text-align: center;
  }
}
#content .feature_wrapper .feature_item .title2 {
  font-size: 28px;
  font-family: "LatoWeb";
}
#content .wrapper .title2 {
  font-size: 18px;
  line-height: 36px;
  padding: 0;
  font-family: "LatoWebBold";
  text-align: left;
}
@media screen and (max-width: 760px) {
  section#content .feature_wrapper .col .des3 {
    padding-bottom: 20px;
  }
}
#content .feature_wrapper .des3 {
  line-height: 32px;
  font-size: 18px;
  font-family: "LatoWebLight";
  color: #666;
}
#content .feature_wrapper .col2 {
  display: inline-block;
  width: 50%;
  /* padding: 0 5%; */
  box-sizing: border-box;
  text-align: center;
  vertical-align: middle;
}
.fl_right {
  float: right;
}
#content .feature_wrapper .col2 img {
  width: 90%;
}
img {
  border: none;
  max-width: 100%;
  vertical-align: middle;
}
#content .line {
  border-bottom: 1px #ccc solid;
  padding-top: 40px;
  margin-bottom: 40px;
}
@media screen and (max-width: 760px) {
div.techabout {
   padding-bottom: 280px;
  }
}
.techabout {
  width: 100%;
  background: url(../assets/heBG.png) no-repeat;
  background-size: 100% 100%;
  padding-bottom: 420px;
}
@media screen and (max-width: 760px) {
  .techabout .tech-fun {

  padding-bottom: 10px;
}
}
.tech-fun {
  width: 100%;
  background: url(../assets/hexinbbj.png) no-repeat;
  background-size: 100% 100%;
  padding-bottom: 100px;
}
@media screen and (max-width: 1300px) {
  .tech-fun .tfbox {
    width: 100%;
  }
}
@media screen and (max-width: 760px) {
  .techabout .tech-fun  .tfbox{
   padding-top: 20px;
}
}
.tfbox {
  width: 1280px;
  margin: 0px auto 0;
  position: relative;
  padding-top: 100px;
}
@media screen and (max-width: 760px) {
  .techabout .tech-fun  .tfbox:after{
   display: none;
}
}
.tfbox:after {
  content: "";
  height: 80px;
  width: 20px;
  background-color: #f9a230;
  position: absolute;
  top: 0px;
  left: 0;
}
.tfbox-top {
  overflow: hidden;
  padding: 0 50px 60px;
}
.tft_left {
  float: left;
  width: 67%;
}
.tft_left span {
  font-size: 14px;
  color: #f9a230;
  line-height: 16px;
}
@media screen and (max-width: 760px) {
  .tfbox-top .tft_left h3 {
    font-size: 20px;
  line-height: 24px;
  }
}
.tft_left h3 {
  padding-top: 10px;
  font-weight: normal;
  color: #fff;
  font-size: 30px;
  line-height: 38px;
}
@media screen and (max-width: 760px) {
  .tfbox-top .tft_left p {
    font-size: 14px;
  line-height: 20px;
  height: 80px;
  display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 4; overflow: hidden;
  }
}
.tft_left p {
  font-size: 16px;
  color: #fff;
  line-height: 32px;
  padding-top: 20px;
}
@media screen and (max-width: 1000px) {
  .tfbox-top .tft_right {
    width: 26%;
  }
}
.tft_right {
  float: right;
  width: 280px;
  background: url(../assets/hexinbbzsb.png) no-repeat;
  background-size: 100% auto;
}
@media screen and (max-width: 1000px) {
  .tfbox-top .tft_right img {
    width: 90%;
  }
}
@media screen and (max-width: 760px) {
  div.tfbox-top .tft_right img {
    margin-top: 10px;
  }
}
.tft_right img {
  margin-top: 20px;
  width: 260px;
  height: auto;
}
@media screen and (max-width: 760px) {
.tfbox .tfbox-bot {
   bottom: -260px;
  padding-bottom:10px;
  }
}
.tfbox-bot {
  position: absolute;
  bottom: -335px;
  left: 0;
  width: 100%;
  background-color: #fff;
  padding:50px 0;
}
@media screen and (max-width: 760px) {
  .tfbox .tfbox-bot h4 {
    font-size: 20px;
  color: #333;
  padding: 10px 0 20px;
  }
}
.tfbox-bot h4 {
  text-align: center;
  font-size: 26px;
  color: #333;
  padding: 40px 0 60px;
}
.tfbox-bot ul {
  padding: 0 10px 0;
  overflow: hidden;
}
@media screen and (max-width: 760px) {
.tfbox .tfbox-bot ul li{
   width:44%;
   border:0;
  }
}
.tfbox-bot ul li {
  width: 28%;
  padding-left: 5%;
  float: left;
  overflow: hidden;
  height: 53px;
  border-right: 1px solid #dcdcdc;
}
.tfbox-bot ul li:nth-child(3n) {
  border: 0;
}
.tfbox-bot ul li img {
  max-height: 24px;
  width: auto;
  float: left;
}
.tfbox-bot ul li p {
  float: left;
  font-size: 16px;
  color: #333;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/technology.vue